module.exports = __webpack_public_path__ + "img/step-7.29007826.jpg";